import { render, staticRenderFns } from "./ImageCarouselComponent.vue?vue&type=template&id=99f9634e&scoped=true&"
import script from "./ImageCarouselComponent.vue?vue&type=script&lang=js&"
export * from "./ImageCarouselComponent.vue?vue&type=script&lang=js&"
import style0 from "./ImageCarouselComponent.vue?vue&type=style&index=0&id=99f9634e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f9634e",
  null
  
)

export default component.exports